import { createDynamicThunk } from ".";

/**
 * LIST Department
 */
export const fetchDepartmentsThunk = createDynamicThunk({
  typePrefix: "departments/fetchDepartmentsThunk",
  useHandleSearch: true,
});

/**
 * ADD / EDIT Department
 */
export const submitDepartmentThunk = createDynamicThunk({
  typePrefix: "departments/submitDepartmentThunk",
  endpoint: "/departments",
  method: "POST",
});

/**
 * Fetch departments without pagination (for dropdowns)
 */
export const fetchDepartmentsSimpleThunk = createDynamicThunk({
  typePrefix: "departments/fetchDepartmentsSimple",
  endpoint: "/fetchWithoutPagination",
  method: "POST",
});
